import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Tag, Icon} from '@blueprintjs/core';
import {IconNames, IconName} from '@blueprintjs/icons';

import {IState} from '../../shared/store/reducers';
import {typePathMap} from '../../shared/utils/typePathMap';
import {typePathIcon} from '../../shared/utils/typePathIcon';
import {REPORT_TYPE} from '../../shared/models';

type FavoriteItemProps = {
  key: string;
  uid: string;
  name: string;
  folderId?: number;
  type: REPORT_TYPE;
  thumbnail?: string;
};

const FavoriteItem = ({uid, name, folderId, type, thumbnail}: FavoriteItemProps) => {
  let path = typePathMap(type);
  const link = `/r/${path}edit/${uid}`;
  const folders = useSelector((state: IState) => state.folder.folders);
  const currentFolder = useMemo(() => folders?.find((f: any) => f.id === folderId), [folderId, folders]);

  return (
    <Link to={link} className="home__content__favlist__link">
      <Card
        className="home__content__favlist__card"
        key={uid}
        interactive={true}
      >
        {thumbnail && (
          <div className="home__content__favlist__card__thumbnail">
            <img src={thumbnail} alt="Thumbnail Preview" />
          </div>
        )}
        <div className="home__content__favlist__card__name">
          <div className="home__content__favlist__card__name__text">
            <Icon icon={typePathIcon(type, {}) as IconName} />
            <span className="bp4-text-overflow-ellipsis">{name}</span>
          </div>
        </div>
        <div className="home__content__favlist__folder">
          {currentFolder && (
            <Tag icon={IconNames.FOLDER_CLOSE} minimal={true}>
              {currentFolder.name}
            </Tag>
          )}
        </div>
      </Card>
    </Link>
  );
};

export default FavoriteItem;
